import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckSquare, File, Info, Phone, MessageSquare, MessageCircle, Plus, GitMerge } from "react-feather";

function Sidebar({ isOpen }) {
  const [isHovered, setHovered] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [showButton, setShowButton] = useState(true);
  const location = useLocation();
  const { pathname } = location;

  const handleMouseEnter = () => {
    if (!isOpen) {
      setHovered(true);
      setShowButton(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isOpen) {
      setHovered(false);
      setShowButton(false);
    }
  };

  const isSidebarExpanded = isOpen || isHovered;

  const toggleMenu = (key) => {
    setActiveMenu((prev) => (prev === key ? null : key));
  };

  const isActive = (path) => {
    return pathname === path || pathname.startsWith(path);
  };

  const handleLinkClick = () => {
    const width = window.innerWidth;
    if (width <= 1200) {
      document.body.classList.remove("sidebar-enable");
    }
  };

 useEffect(() => {
  if (pathname.includes("/sellerlist")) {
    setActiveMenu("sellers");
  } else if (pathname.includes("/buyerlist")) {
    setActiveMenu("buyer");
  } else if (pathname.includes("/productlist")) {
    setActiveMenu("product");
  } else if (pathname.includes("/productRequestlist")) {
    setActiveMenu("productRequest");
  } else if (pathname.includes("/intermediatelist")) {
    setActiveMenu("intermediate");
  } else if (pathname.includes("/intermediateproducts")) {
    setActiveMenu("intermediateActivity");
  } else if (pathname.includes("/intermediaterequests")) {
    setActiveMenu("intermediateActivity");
  } else if (pathname.includes("/matchlist")) {
    setActiveMenu("match");
  } else if (pathname.includes("/contactlist")) {
    setActiveMenu("support");
  } else if (pathname === "/teamlist") {
    setActiveMenu("teamManagement");
  } else if (pathname === "/chat") {
    setActiveMenu("chat");
  } else if (pathname.includes("/faqlist")) {
    setActiveMenu("support");
  } else if (pathname.includes("/password")) {
    setActiveMenu("settings");
  } else {
    setActiveMenu(null);
  }
}, [pathname]);

  return (
    <div
      className={`vertical-menu ${isSidebarExpanded ? "hovered" : "collapsed"}`}
      onMouseEnter={() => {
        handleMouseEnter();
        document.body.classList.add("hovered");
      }}
      onMouseLeave={() => {
        handleMouseLeave();
        document.body.classList.remove("hovered");
      }}
    >
      <div className="navbar-brand-box">
        <Link to="/dashboard" className="logo" onClick={handleLinkClick}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span className="logo-lg">
              <img src="images/logo.png" alt="" height={20} />
            </span>
            <h6 style={{ margin: 5, color: "black", fontSize: "26px" }}>WTE</h6>
          </div>
        </Link>
        <button
          type="button"
          className="btn btn-sm hide-menu-btn"
          onClick={() => {
            const body = document.body;
            body.classList.toggle("sidebar-enable");
            body.classList.remove("hovered");
            setHovered(false);
            setShowButton(false);

            if (window.innerWidth >= 1200) {
              body.classList.toggle("vertical-collapsed");
            } else {
              body.classList.remove("vertical-collapsed");
            }
          }}
          style={{
            display: isSidebarExpanded && showButton ? "block" : "none",
          }}
        >
          <i className="fe-x"></i>
        </button>
      </div>
      <div data-simplebar="" className="sidebar-menu-scroll mt-1">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className={isActive("/dashboard") ? "mm-active" : ""}>
              <Link to="/dashboard" onClick={handleLinkClick}>
                <i className="ri-pie-chart-2-fill" />
                <span>Dashboard</span>
              </Link>
            </li>

            {/* <li className={activeMenu === "users" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("sellers")}
              >
                <i className="uil-user-square" />
                <span>Users</span>
              </Link>
              {isSidebarExpanded && activeMenu === "sellers" && (
                <ul className="sub-menu mm-show">
                  <li>
                    <Link
                      className={isActive("/sellerlist") ? "active" : ""}
                      to="/sellerlist"
                      onClick={handleLinkClick}
                    >
                      seller listings
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            
            
            <li className={activeMenu === "agent" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("buyer")}
              >
                <i className="uil-users-alt" />
                <span>Buyers</span>
              </Link>
              {isSidebarExpanded && activeMenu === "buyer" && (
                <ul className="sub-menu mm-show">
                  <li>
                    <Link
                      className={isActive("/buyerList") ? "active" : ""}
                      to="/buyerList"
                      onClick={handleLinkClick}
                    >
                      Buyer listings
                    </Link>
                  </li>
                </ul>
              )}
            </li>
             
             
             
             <li className={activeMenu === "intermediate" ? "mm-active" : ""}>
               <Link
                 className="has-arrow waves-effect"
                 onClick={() => toggleMenu("intermediate")}
               >
                 <i className="uil-users-alt" />
                 <span>Intermediates</span>
               </Link>
               {isSidebarExpanded && activeMenu === "intermediate" && (
                 <ul className="sub-menu mm-show">
                   <li>
                     <Link
                       className={isActive("/intermediatelist") ? "active" : ""}
                       to="/intermediatelist"
                       onClick={handleLinkClick}
                     >
                       Intermediate Listings
                     </Link>
                   </li>
                 </ul>
                )}
              </li> */}

            <li className={activeMenu === "users" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("users")}
              >
                <i className="uil-user-square" />
                <span>Users</span>
              </Link>

              {isSidebarExpanded && activeMenu === "users" && (
                <ul className="sub-menu mm-show">

                  {/* Sellers */}
                  <li>
                    <Link
                      className={isActive("/sellerlist") ? "active" : ""}
                      to="/sellerlist"
                      onClick={handleLinkClick}
                    >
                      Seller Listings
                    </Link>
                  </li>

                  {/* Buyers */}
                  <li>
                    <Link
                      className={isActive("/buyerList") ? "active" : ""}
                      to="/buyerList"
                      onClick={handleLinkClick}
                    >
                      Buyer Listings
                    </Link>
                  </li>

                  {/* Intermediates */}
                  <li>
                    <Link
                      className={isActive("/intermediatelist") ? "active" : ""}
                      to="/intermediatelist"
                      onClick={handleLinkClick}
                    >
                      Intermediary Listings
                    </Link>
                  </li>

                </ul>
              )}
            </li>


            {/* <li className={activeMenu === "product" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("product")}
              >
                <i className="uil-user-square" />
                <span> Products</span>
              </Link>
              {isSidebarExpanded && activeMenu === "product" && (
                <ul className="sub-menu mm-show">
                  <li>
                    <Link
                      className={isActive("/productlist") ? "active" : ""}
                      to="/productlist"
                      onClick={handleLinkClick}
                    >
                      Seller's Product                    </Link>
                  </li>
                </ul>
              )}
            </li> */}

            <li className={activeMenu === "product" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("product")}
              >
                <i className="uil-user-square" />
                <span>Products</span>
              </Link>

              {isSidebarExpanded && activeMenu === "product" && (
                <ul className="sub-menu mm-show">

                  {/* Seller Products */}
                  <li>
                    <Link
                      className={isActive("/productlist") ? "active" : ""}
                      to="/productlist"
                      onClick={handleLinkClick}
                    >
                      Seller's Product
                    </Link>
                  </li>

                  {/* Intermediate Products */}
                  <li>
                    <Link
                      className={isActive("/intermediateproducts") ? "active" : ""}
                      to="/intermediateproducts"
                      onClick={handleLinkClick}
                    >
                      Intermediary Products
                    </Link>
                  </li>

                  {/* Add Product (for Sellers & Intermediates) */}
                  {/* <li>
         <Link
           className={isActive("/add-product") ? "active" : ""}
           to="/add-product"
           onClick={handleLinkClick}
         >
           <Plus size={18} className="me-1" /> Add Product
         </Link>
       </li> */}

                </ul>
              )}
            </li>

            {/* <li className={activeMenu === "productRequest" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("productRequest")}
              >
                <i className="uil-users-alt" />
                <span> Requests</span>
              </Link>
              {isSidebarExpanded && activeMenu === "productRequest" && (
                <ul className="sub-menu mm-show">
                  <li>
                    <Link
                      className={isActive("/productRequestlist") ? "active" : ""}
                      to="/productRequestlist"
                      onClick={handleLinkClick}
                    >
                       Buyer's Request
                    </Link>
                  </li>
                </ul>
              )}
            </li> */}

            <li className={activeMenu === "productRequest" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("productRequest")}
              >
                <i className="uil-users-alt" />
                <span>Requests</span>
              </Link>

              {isSidebarExpanded && activeMenu === "productRequest" && (
                <ul className="sub-menu mm-show">

                  {/* Buyer Requests */}
                  <li>
                    <Link
                      className={isActive("/productRequestlist") ? "active" : ""}
                      to="/productRequestlist"
                      onClick={handleLinkClick}
                    >
                      Buyer's Request
                    </Link>
                  </li>

                  {/* Intermediate Requests */}
                  <li>
                    <Link
                      className={isActive("/intermediaterequests") ? "active" : ""}
                      to="/intermediaterequests"
                      onClick={handleLinkClick}
                    >
                      Intermediary Requests
                    </Link>
                  </li>

                </ul>
              )}
            </li>
            <li className={activeMenu === "match" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("match")}
              >
                <GitMerge/>
                <span> Matches</span>
              </Link>
              {isSidebarExpanded && activeMenu === "match" && (
                <ul className="sub-menu mm-show">
                  <li>
                    <Link
                      className={isActive("/matchlist") ? "active" : ""}
                      to="/matchlist"
                      onClick={handleLinkClick}
                    >
                      Match List
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* <li className={activeMenu === "intermediateActivity" ? "mm-active" : ""}>
                <Link
                  className="has-arrow waves-effect"
                  onClick={() => toggleMenu("intermediateActivity")}
                >
                  <i className="uil-users-alt" />
                  <span>Intermediate Activity</span>
                </Link>
                {isSidebarExpanded && activeMenu === "intermediateActivity" && (
                  <ul className="sub-menu mm-show">
                    <li>
                      <Link
                        className={isActive("/intermediateproducts") ? "active" : ""}
                        to="/intermediateproducts"
                        onClick={handleLinkClick}
                      >
                        Intermediate Products
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={isActive("/intermediaterequests") ? "active" : ""}
                        to="/intermediaterequests"
                        onClick={handleLinkClick}
                      >
                        Intermediate Requests
                      </Link>
                    </li>
                  </ul>
                )}
              </li> */}

            <li className={activeMenu === "support" ? "mm-active" : ""}>
              <Link
                className="has-arrow waves-effect"
                onClick={() => toggleMenu("support")}
              >
                <i className="ri-customer-service-2-fill" />
                <span>Support</span>
              </Link>
              {isSidebarExpanded && activeMenu === "support" && (
                <ul className="sub-menu mm-show">

                  <li>
                    <Link
                      className={isActive("/contactlist") ? "active" : ""}
                      to="/contactlist"
                      onClick={handleLinkClick}
                    >
                      Contact Us
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className={isActive("/chat") ? "mm-active" : ""}>
              <Link to="/chat" onClick={handleLinkClick}>
                <MessageCircle />
                <span>Chat</span>
              </Link>
            </li>
            <li className={isActive("/aboutus") ? "mm-active" : ""}>
              <Link to="/aboutus" onClick={handleLinkClick}>
                <Info />
                <span>About Us</span>
              </Link>
            </li>

            <li className={isActive("/privacypolicy") ? "mm-active" : ""}>
              <Link to="/privacypolicy" onClick={handleLinkClick}>
                <File />
                <span>Privacy Policy</span>
              </Link>
            </li>

            <li className={isActive("/termsConditions") ? "mm-active" : ""}>
              <Link to="/termsConditions" onClick={handleLinkClick}>
                <CheckSquare />
                <span>Terms & Conditions</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
